import { Checkbox } from '@mui/material'
import { CheckBoxDiv, CheckBoxTitle } from './style'

const CheckBoxMade = ({ autoId, setAutoId, className }) => {
  return (
    <CheckBoxDiv className={className}>
      <Checkbox
        checked={autoId}
        onClick={() => (autoId ? setAutoId(false) : setAutoId(true))}
        sx={{ width: '24px', height: '24px', padding: '0px 3px 0px 0px' }}
        color="success"
      />
      <CheckBoxTitle>Automático</CheckBoxTitle>
    </CheckBoxDiv>
  )
}
export default CheckBoxMade
